/* Shopify owns customers, inventory and payments. No private credentials belong here. */
(() => {
  'use strict';
  const getDialogs = () => Array.from(document.querySelectorAll('[data-piece-dialog]'));
  const openers = new WeakMap();
  const clean = value => String(value || '').replace(/[^a-zA-Z0-9-]/g, '').slice(0, 64);

  function updateTags(form) {
    const input = form.querySelector('[data-signup-tags]');
    if (!input) return;
    const values = ['newsletter', 'plate-theory', 'drop-001'];
    form.querySelectorAll('[data-piece-choice]:checked').forEach(choice => {
      const code = clean(choice.value).toLowerCase();
      if (code) values.push('pt-design:' + code);
    });
    // Compatibility with older sections while a theme-editor preview reloads.
    const single = form.querySelector('[data-piece-select]');
    if (single && clean(single.value)) values.push('pt-design:' + clean(single.value).toLowerCase());
    const size = form.querySelector('[data-size-select]');
    if (size && ['S', 'M', 'L', 'XL', 'XXL'].includes(size.value)) values.push('pt-size:' + size.value);
    input.value = Array.from(new Set(values)).join(',');
  }

  function selectPiece(code) {
    const aliases = { 'plate-theory-core': 'core-theory', stars: 'stellar-mass', 'globe-plate': 'world-plate' };
    const canonical = aliases[code] || code;
    document.querySelectorAll('.early-form').forEach(form => {
      form.querySelectorAll('[data-piece-choice]').forEach(choice => {
        if (choice.value === canonical || choice.dataset.productHandle === code) choice.checked = true;
      });
      const single = form.querySelector('[data-piece-select]');
      if (single && Array.from(single.options).some(option => option.value === canonical)) single.value = canonical;
      updateTags(form);
    });
  }

  function closeDialog(dialog) { if (dialog && dialog.open) dialog.close(); }
  function openPiece(code, trigger, updateUrl = true) {
    const dialog = getDialogs().find(item => item.dataset.pieceDialog === code);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    getDialogs().forEach(closeDialog);
    if (trigger) openers.set(dialog, trigger);
    dialog.showModal();
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('piece', code);
      url.hash = 'the-drop';
      window.history.replaceState(null, '', url);
    }
    return true;
  }

  function syncVariant(select, updateUrl) {
    const option = select.selectedOptions[0];
    const form = select.form;
    if (!form) return;
    const summary = select.closest('.product-summary');
    const price = summary && summary.querySelector('[data-variant-price]');
    const add = form.querySelector('[data-add-to-cart]');
    const wallet = form.querySelector('[data-accelerated-checkout]');
    const quantity = form.querySelector('[name=quantity]');
    const available = Boolean(option && option.value && option.dataset.available === 'true' && !option.disabled);
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    if (add && form.dataset.pending !== 'true') { add.disabled = !available; add.textContent = available ? 'Add to bag' : 'Unavailable'; }
    if (wallet) wallet.hidden = !available;
    if (quantity && option) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
    }
    if (updateUrl && option && option.value) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(null, '', url);
    }
  }

  async function addToBag(event, form) {
    // Do not intercept Shopify's accelerated-payment buttons or other app actions.
    if (!event.submitter || !event.submitter.matches('[data-add-to-cart]') || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.pending === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('[data-add-to-cart]');
    const message = form.querySelector('[data-product-error]');
    const payload = new FormData(form);
    const addUrl = new URL(form.dataset.addUrl + '.js', window.location.origin);
    const cartUrl = new URL(form.dataset.cartUrl, window.location.origin);
    if (addUrl.origin !== window.location.origin || cartUrl.origin !== window.location.origin) return;
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';
    if (message) { message.hidden = true; message.textContent = ''; }
    try {
      const response = await fetch(addUrl.href, { method: 'POST', body: payload, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok || data.status >= 400 || !data.id) {
        const error = typeof data.description === 'string' ? data.description : 'This item could not be added. Check your size and quantity, then try again.';
        throw new Error(error);
      }
      window.location.assign(cartUrl.href);
    } catch (error) {
      if (message) {
        message.textContent = error instanceof TypeError || error instanceof SyntaxError ? 'We could not confirm the request. Check your bag before trying again.' : error.message;
        message.hidden = false;
        message.focus();
      }
      delete form.dataset.pending;
      form.removeAttribute('aria-busy');
      const select = form.querySelector('[data-variant-select]');
      if (select) syncVariant(select, false);
    }
  }

  function setup(root = document) {
    root.querySelectorAll('[data-preference-fields]').forEach(element => { element.hidden = false; });
    root.querySelectorAll('.early-form').forEach(form => {
      updateTags(form);
      if (form.dataset.ptReady) return;
      form.dataset.ptReady = 'true';
      form.addEventListener('change', () => updateTags(form));
      // Native POST; only Shopify's response may confirm a saved subscription.
      form.addEventListener('submit', () => updateTags(form));
    });
    root.querySelectorAll('[data-piece-dialog]').forEach(dialog => {
      if (dialog.dataset.ptReady) return;
      dialog.dataset.ptReady = 'true';
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
      });
      dialog.addEventListener('close', () => {
        const opener = openers.get(dialog);
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      syncVariant(select, false);
      if (select.dataset.ptReady) return;
      select.dataset.ptReady = 'true';
      select.addEventListener('change', () => syncVariant(select, true));
    });
    root.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.ptReady) return;
      form.dataset.ptReady = 'true';
      form.addEventListener('submit', event => addToBag(event, form));
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const preview = event.target.closest('[data-open-piece]');
    if (preview && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      if (openPiece(preview.dataset.openPiece, preview)) event.preventDefault();
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) closeDialog(close.closest('dialog'));
    const waitlist = event.target.closest('[data-waitlist-piece]');
    if (waitlist) {
      selectPiece(waitlist.dataset.waitlistPiece);
      getDialogs().forEach(closeDialog);
      const url = new URL(window.location.href);
      url.searchParams.set('piece', waitlist.dataset.waitlistPiece);
      url.hash = 'early-access';
      window.history.replaceState(null, '', url);
      const access = document.querySelector('#early-access');
      if (access) access.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const email = document.querySelector('.early-form input[type=email]');
      if (email) email.focus({ preventScroll: true });
    }
    if (event.target.closest('.mobile-nav nav a')) document.querySelector('.mobile-nav')?.removeAttribute('open');
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelector('.mobile-nav')?.removeAttribute('open'); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-product-form]').forEach(form => { delete form.dataset.pending; form.removeAttribute('aria-busy'); });
    document.querySelectorAll('[data-variant-select]').forEach(select => syncVariant(select, false));
  });
  setup();
  const code = new URL(window.location.href).searchParams.get('piece');
  if (code) {
    // Opening a preview is not an expression of interest; only explicit signup links select it.
    if (window.location.hash === '#early-access') selectPiece(code); else openPiece(code, null, false);
  }
  document.querySelector('[data-form-result]')?.focus({ preventScroll: false });
})();
